export default __webpack_public_path__ + "static/media/LoginLogo.07532e42.svg";